var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVector = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 38,
  height: 44,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Vector_svg__a)",
  d: "M.25 1.688A1.56 1.56 0 0 1 1.813.125h34.375a1.563 1.563 0 0 1 0 3.125h-3.126v3.125a14.06 14.06 0 0 1-7.99 12.688c-.906.434-1.384 1.178-1.384 1.843v2.188c0 .665.48 1.41 1.384 1.843a14.06 14.06 0 0 1 7.99 12.688v3.125h3.126a1.563 1.563 0 0 1 0 3.125H1.813a1.563 1.563 0 1 1 0-3.125h3.125v-3.125a14.06 14.06 0 0 1 7.99-12.687c.906-.435 1.384-1.179 1.384-1.844v-2.188c0-.665-.48-1.41-1.384-1.843a14.06 14.06 0 0 1-7.99-12.688V3.25H1.813A1.56 1.56 0 0 1 .25 1.688M8.063 3.25v3.125a10.94 10.94 0 0 0 6.215 9.869c1.666.8 3.16 2.472 3.16 4.66v2.193s.562.465 1.562.465 1.563-.468 1.563-.468v-2.188c0-2.19 1.493-3.862 3.159-4.662a10.94 10.94 0 0 0 6.215-9.869V3.25z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "Vector_svg__a",
  x1: 37.75,
  x2: 0.25,
  y1: 22,
  y2: 22,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00CBA9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#09F"
})))));
export default SvgVector;